var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password_reset"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M554.48,339.28V312.11q0-24.12-15.9-41T500,254.24h-400a51.71,51.71,0,0,0-20.22,3.88,47.6,47.6,0,0,0-6,2.94A51.59,51.59,0,0,0,65.6,267h0a61.22,61.22,0,0,0-13.5,16.88,55.57,55.57,0,0,0-5.47,15.29v0a64.21,64.21,0,0,0-1.24,13v27.14c0,.06,0,.11,0,.19V549.12a49.57,49.57,0,0,0,6.73,25.63,53.15,53.15,0,0,0,9.17,11.51A54.43,54.43,0,0,0,77.2,597,56,56,0,0,0,99,601.53l.9,0H500l1,0q22.09-.33,37.65-15.27,15.93-15.3,15.92-37.14V339.44C554.5,339.38,554.48,339.34,554.48,339.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.31,379.79c0-32.22-27.18-58.34-60.71-58.34s-60.71,26.12-60.71,58.34A57.27,57.27,0,0,0,265,424v81.88a39.76,39.76,0,0,0,39.64,39.64h0a39.75,39.75,0,0,0,39.63-39.64V424A57.28,57.28,0,0,0,365.31,379.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.57,64.54l28,36.33c11.88,19.39,8.53,44.09-6.91,58.43-17.53,16.28-46.92,15.72-65.12-3l-28-36.33q-20-26-52.9-29.56-30.6-3.37-56.15,14.41c-1.27.89-2.53,1.8-3.77,2.75q-27,20.8-31.92,53.55t15,58.69l28,36.33-72,55.46-28-36.33a167.25,167.25,0,0,1-11.54-17.08,156.26,156.26,0,0,1-20.64-62.9,170.57,170.57,0,0,1,13-86.51,173.06,173.06,0,0,1,54.79-70.42c1.24-1,2.48-1.89,3.72-2.81A172.43,172.43,0,0,1,250.53,3.43,170.42,170.42,0,0,1,337.47,13,156.54,156.54,0,0,1,406.57,64.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password_reset.43cda2aa087a6cd1a14f9b5d39d8ba4a.svg";
export { ForwardRef as ReactComponent };